import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as moment from 'moment';

import { AuditTrailType } from './audit-trail-type';
import { Settings } from '../../core';

export class AuditTrailRecordsFile {
    public data: Blob;
    public filename: string;
}

@Injectable()
export class AuditTrailRecordsStorage {
    constructor(
        private http: HttpClient,
        private settings: Settings
    ) { }

    public getRecordsCsvFile(trailType: AuditTrailType, fromDate: moment.Moment, toDate: moment.Moment): Observable<AuditTrailRecordsFile> {
        const params = new HttpParams()
            .set('fromDate', fromDate.format('YYYY-MM-DD'))
            .set('toDate', toDate.format('YYYY-MM-DD'));

        return this.http.get(`${this.settings.apiUrl}/admin/audit-trail/${encodeURI(trailType.toString())}/csv`, { params: params, responseType: 'blob', observe: 'response' })
            .pipe(
                map((response: HttpResponse<Blob>) => {
                    const auditTrailRecords: AuditTrailRecordsFile = {
                        data: response.body,
                        filename: this.getFileName(response)
                    };

                    return auditTrailRecords;
                })
            );
    }

    private getFileName(response: HttpResponse<Blob>): string {
        const defaultFileName = 'events.csv';
        const fileNameHeader = response.headers.get('content-disposition');

        if (!fileNameHeader) {
            return defaultFileName;
        }

        const fileName = fileNameHeader.split('filename=')[1] || defaultFileName;
        return fileName;
    }
}